(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.currentScript.closest('accordion-custom');
    if (!root) return;

    const detailsList = root.querySelectorAll('details.details[data-testid="accordion-details"]');

    detailsList.forEach((d) => {
      d.addEventListener('toggle', () => {
        if (!d.open) return;

        detailsList.forEach((other) => {
          if (other !== d) other.removeAttribute('open');
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
